import { render } from "./ProfileOpinionsList.vue?vue&type=template&id=77b894c8&scoped=true"
import script from "./ProfileOpinionsList.vue?vue&type=script&lang=js"
export * from "./ProfileOpinionsList.vue?vue&type=script&lang=js"

import "./ProfileOpinionsList.vue?vue&type=style&index=0&id=77b894c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b894c8"]])

export default __exports__